import { useAppSelector } from "redux/hooks";

const useMerchandisePreferences = () => {
  const preferences = useAppSelector((state) => state.user.preferences);

  return {
    preferences,
    showNewAdvertisingDashboard: true,
  };
};

export default useMerchandisePreferences;
